// Stable keys + Vietnamese labels for fields a viewer's permissions can toggle.
// Used by AccountManagement.js (UI) and AccountStatusTable.js / Reports.js (gating).

// `account` is alwaysOn — table needs an account identifier in every row, otherwise
// rows have no anchor. Other columns are admin-toggleable.
export const DASHBOARD_COLUMNS = [
  { key: 'account',           label: 'Tài khoản',  alwaysOn: true },
  { key: 'name',              label: 'Tên' },
  { key: 'balance',           label: 'Balance' },
  { key: 'floating',          label: 'Vị thế (floating P/L)' },
  { key: 'closed',            label: 'Đã chốt' },
  { key: 'total_profit',      label: 'Tổng LN' },
  { key: 'buy_positions',     label: 'Vị thế Buy' },
  { key: 'buy_lots',          label: 'Lot Buy' },
  { key: 'sell_positions',    label: 'Vị thế Sell' },
  { key: 'sell_lots',         label: 'Lot Sell' },
  { key: 'buy_pending',       label: 'Chờ Buy' },
  { key: 'buy_pending_lots',  label: 'LChờ Buy' },
  { key: 'sell_pending',      label: 'Chờ Sell' },
  { key: 'sell_pending_lots', label: 'LChờ Sell' },
  { key: 'group',             label: 'Group' },
  { key: 'copy_ratio',        label: 'Tỷ lệ' },
  { key: 'max_loss',          label: 'SL cứng' },
  { key: 'status',            label: 'T.thái' },
  { key: 'updated_at',        label: 'Cập nhật' },
];

export const REPORTS_SUB_TABS = [
  { key: 'transactions',  label: 'Nạp / Rút tiền' },
  { key: 'profit',        label: 'Lợi nhuận tài khoản' },
  { key: 'setup_history', label: 'Lịch sử thông số' },
  { key: 'error_logs',    label: 'Lịch sử lỗi' },
];

// Sub-tab keys aligned with the order rendered in Reports.js. Used to map between
// the active tab index and the permission key (e.g. tab index 1 ↔ 'profit').
export const REPORTS_TAB_ORDER = REPORTS_SUB_TABS.map(t => t.key);

// Sub-tabs of the Hiệu suất Master page. `overview` is the existing metrics
// dashboard; `psychology` is the Đánh giá cảm xúc tab fed by the
// Trader_Spychology_Monitor EA. Stored in permissions.master_performance.sub_tabs
// (with optional per-account overrides under master_performance.account_overrides).
export const MASTER_PERF_SUB_TABS = [
  { key: 'overview',   label: 'Tổng quan' },
  { key: 'psychology', label: 'Đánh giá cảm xúc' },
];
